<template>
  <div class="container py-5">
    <div class="row">
      <div class="col-12">
        <h1 class="mb-3">{{ vaga.titulo }}</h1>

        <div class="row align-items-center">
          <div class="col-md-6">
            <p class="mb-0">
              <b>Prazo: {{ formatarDataBrasileira(vaga.prazo?.substr(0, 10)) }}</b>
            </p>
          </div>
          <div class="col-md-6 text-end">
            <span v-if="vaga.statuss === 'aberta' && prazoAberto" class="alert alert-success">
              aceitando candidatura
            </span>
            <span v-else class="alert alert-danger">
              candidaturas encerradas
            </span>
          </div>
        </div>

        <!-- NOVO: Aprovado(s) - só mostra se vier preenchido -->
        <div v-if="vaga.aprovado && vaga.aprovado.trim()" class="mt-3">
          <div class="alert alert-primary mb-0 mt-5">
            <b>Aprovado(s):</b> {{ vaga.aprovado }}
          </div>
        </div>

        <div class="mt-4">
          <h5>Descrição/Informações</h5>
          <p v-html="vaga.descricao.replace(/\n/g, '<br>')"></p>
        </div>

        <div class="mt-4">
          <h5>Requisitos</h5>
          <p v-html="vaga.requisitos.replace(/\n/g, '<br>')"></p>
        </div>

        <div class="mt-4">
          <p><b>Local:</b> {{ vaga.local_trabalho }}</p>
          <p><b>Unidade Cultural / Núcleo:</b> {{ vaga.nucleo_regional }}</p>
          <p><b>Formato:</b> {{ vaga.formato }}</p>
          <p><b>Modalidade:</b> {{ vaga.modalidade_contratacao }}</p>
          <p><b>Jornada:</b> {{ vaga.jornada }}</p>
          <p><b>Faixa Salarial:</b> {{ vaga.faixa_salarial }}</p>
        </div>

        <div class="mt-4" v-if="vaga.statuss === 'aberta' && prazoAberto">
          <button v-if="mostrarBotaoCandidatar" class="btn btn-outline-success" @click="candidatar">
            Candidatar-se
          </button>
          <div v-else-if="jaCandidatou" class="alert alert-info mb-0">
            Você já se candidatou para esta vaga.
          </div>
        </div>
        <div v-else>
          <span class="badge px-5 py-2 bg-danger">Vaga encerrada</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: "VagaDetalheVie",
  data() {
    return {
      vaga: {
        id: null,
        titulo: '',
        descricao: '',
        requisitos: '',
        local_trabalho: '',
        nucleo_regional: '',
        formato: '',
        modalidade_contratacao: '',
        jornada: '',
        faixa_salarial: '',
        statuss: '',
        prazo: '',
        aprovado: null, // NOVO
      },
      jaCandidatou: false,
      usuario: null,
    };
  },
  computed: {
    prazoAberto() {
      if (!this.vaga.prazo) return false;
      const prazo = new Date(this.vaga.prazo);
      const agora = new Date();
      return prazo >= agora;
    },
    mostrarBotaoCandidatar() {
      // Só mostra o botão se for candidato, não tiver se candidatado e estiver logado
      return (
        this.usuario &&
        this.usuario.tipo === 'candidato' &&
        !this.jaCandidatou
      );
    }
  },
  async mounted() {
    const id = this.$route.params.id;
    const res = await api.get(`buscar_vaga.php?id=${id}`);
    this.vaga = res.data;

    // Verifica se o usuário é candidato e já se candidatou
    const usuario = JSON.parse(localStorage.getItem('usuario'));
    this.usuario = usuario;
    if (usuario && usuario.tipo === 'candidato') {
      try {
        const check = await api.get('minhas_candidaturas.php', {
          params: { usuario_id: usuario.id }
        });
        this.jaCandidatou = Array.isArray(check.data)
          ? check.data.some(c => c.id == this.vaga.id)
          : false;
      } catch {
        this.jaCandidatou = false;
      }
    }
  },
  methods: {
    async candidatar() {
      if (!this.prazoAberto) {
        alert('Candidaturas encerradas para esta vaga.');
        return;
      }
      if (!this.usuario || this.usuario.tipo !== 'candidato') {
        alert('Você precisa estar logado como candidato para se candidatar.');
        return;
      }
      try {
        await api.post('candidatar.php', {
          usuario_id: this.usuario.id,
          vaga_id: this.vaga.id,
        });
        alert('Candidatura registrada com sucesso!');
        this.jaCandidatou = true;
      } catch (error) {
        alert(error.response?.data?.erro || 'Erro ao se candidatar.');
      }
    },
    formatarDataBrasileira(dataISO) {
      if (!dataISO) return '';
      const [ano, mes, dia] = dataISO.split('-');
      return `${dia}/${mes}/${ano}`;
    }
  },
};
</script>
